<template>
  <v-app id="app">
    <v-content v-if="!appInitialized" class="full-screen">
      <v-layout fill-height align-center justify-center ma-0>
        <v-progress-circular indeterminate color="black" />
      </v-layout>
    </v-content>
    <div v-show="appInitialized">
      <v-progress-linear
        :active="loading"
        :indeterminate="true"
        class="app-loader ma-0"
        background-color="transparent"
      />
      <v-content data-iframe-height>
        <v-container class="pa-0 app-container" fluid>
          <v-layout wrap class="ma-0">
            <v-flex xs12 md4 align-start class="app-filter">
              <app-filter />
            </v-flex>
            <v-flex xs12 md8>
              <filtered-swiper />
            </v-flex>
          </v-layout>
          <navigation-swiper />
        </v-container>
      </v-content>
    </div>
  </v-app>
</template>

<script>
import FilteredSwiper from '@/components/FilteredSwiper.vue'
import NavigationSwiper from '@/components/NavigationSwiper.vue'
import AppFilter from '@/components/AppFilter.vue'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'home',
  components: {
    AppFilter,
    FilteredSwiper,
    NavigationSwiper,
  },
  computed: {
    ...mapState(['loading', 'appInitialized']),
  },
  mounted() {
    this.getCategories()
  },
  methods: {
    ...mapActions(['getCategories']),
  },
}
</script>

<style lang="scss">
// Attempt to fix iOS bug where iframe extends past the width of the device
// https://github.com/davidjbradshaw/iframe-resizer/issues/183
body,
#app {
  width: 1px;
  min-width: 100%;
}

@font-face {
  font-family: 'ProximaNovaAlt';
  font-style: normal;
  font-weight: normal;
  font-display: swap;
  src: url('/fonts/ProximaNovaAltRegular/mark-simonson-proxima-nova-alt-regular.eot');
  src: url('/fonts/ProximaNovaAltRegular/mark-simonson-proxima-nova-alt-regular.woff2')
      format('woff2'),
    url('/fonts/ProximaNovaAltRegular/mark-simonson-proxima-nova-alt-regular.woff')
      format('woff'),
    url('/fonts/ProximaNovaAltRegular/mark-simonson-proxima-nova-alt-regular.ttf')
      format('truetype'),
    url('/fonts/ProximaNovaAltRegular/mark-simonson-proxima-nova-alt-regular.eot#iefix')
      format('embedded-opentype');
}

@font-face {
  font-family: 'ProximaNovaAlt';
  font-style: normal;
  font-weight: bold;
  font-display: swap;
  src: url('/fonts/ProximaNovaAltBold/mark-simonson-proxima-nova-alt-bold.eot');
  src: url('/fonts/ProximaNovaAltBold/mark-simonson-proxima-nova-alt-bold.woff2')
      format('woff2'),
    url('/fonts/ProximaNovaAltBold/mark-simonson-proxima-nova-alt-bold.woff')
      format('woff'),
    url('/fonts/ProximaNovaAltBold/mark-simonson-proxima-nova-alt-bold.ttf')
      format('truetype'),
    url('/fonts/ProximaNovaAltBold/mark-simonson-proxima-nova-alt-bold.eot#iefix')
      format('embedded-opentype');
}

@font-face {
  font-family: 'AIModern';
  font-style: normal;
  font-weight: normal;
  font-display: swap;
  src: url('/fonts/AIModern/modern-no-216-regular.eot');
  src: url('/fonts/AIModern/modern-no-216-regular.woff2') format('woff2'),
    url('/fonts/AIModern/modern-no-216-regular.woff') format('woff'),
    url('/fonts/AIModern/modern-no-216-regular.ttf') format('truetype'),
    url('/fonts/AIModern/modern-no-216-regular.eot#iefix')
      format('embedded-opentype');
}

#app {
  font-family: 'ProximaNovaAlt', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: white;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}

.app-container {
  // max-width: 1440px !important;
}

.app-loader {
  position: fixed !important;
  top: 0;
  left: 0;
  z-index: 5;
}

.app-filter {
  background-color: #eaebeb;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 20px !important;
  padding-bottom: 20px !important;
  margin-bottom: 20px;

  @media (min-width: 960px) {
    margin-bottom: 0;
    padding-top: 60px !important;
    padding-bottom: 60px !important;
  }
}

input[type='number'] {
  -moz-appearance: textfield;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

// Vuetify overrides

.v-menu__content.menuable__content__active {
  overflow-y: scroll;
}

.v-select {
  .v-select__slot {
    min-height: 36px;
    align-items: flex-start;
  }

  .v-select--chips {
    .v-select__slot {
      height: 40px;
    }
  }

  &.v-input {
    margin-top: 0;
    padding-top: 6px;
  }

  .v-chip {
    font-size: 18px;
  }
}

.v-input__slot .v-label,
.v-input__slot,
.v-select__selection {
  font-size: 18px;
  line-height: 1.25;
}

button.v-btn {
  border-radius: 0;
  height: 48px;
  font-size: 12px;
  letter-spacing: 0.75px;
  line-height: 1.15;
  &:not(.v-btn--depressed):not(.v-btn--flat) {
    box-shadow: 0px 11px 20px -8px rgba(0, 0, 0, 0.4) !important;
  }
  &:hover,
  &:focus {
    &:before {
      background-color: initial !important;
    }
  }
}
</style>
